<script>
export default {
  name: 'EntrySiderItem',
  props: {
    menu: {
      type: Object,
      default: () => {}
    },
    visible: {
      type: Boolean,
      default: false
    },
    currentLang: {
      type: String,
      default: 'zh_CN'
    },
    scrollTop: {
      type: [Number, String],
      default: 0
    },
    activeKey: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      timer: null
    }
  },
  methods: {
    toggle (menu) {
      menu.hidden = !menu.hidden
    },
    handleClick (menu) {
      this.$emit('click', menu)
    },
    handleMousemove (menu) {
      this.$emit('mousemove', menu)
    },
    handleMouseout () {
      this.$emit('mouseout')
    },
    handlePushpin (e) {
      this.$emit('pushpin', e)
    },
    handleMenuChange (e) {
      this.$emit('menuchange', e)
    },
    handleClearTimeout () {
      clearTimeout(this.timer)
      this.timer = null
    },
    handleChildrenMousemove (e) {
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.$parent.clear()
        }, 100)
      }
    },
    menuRender (menu) {
      const { activeKey, handleClick, handleMousemove, handleMouseout, currentLang, menuItemRender } = this
      const menuIcon = menu.icon
        ? ((~menu.icon.indexOf('http')) && <a-avatar shape="square" src={menu.icon} />) ||
          ((~menu.icon.indexOf('gb-icon-')) && <icon-font type={menu.icon} />) ||
          (<a-icon type={menu.icon} />)
        : (<a-icon type="thunderbolt" />)
      const menuTab = menu.menuName?.[currentLang] || menu.tab
      const menuChild = (menu.childMenus && menu.childMenus.length && menu.childMenus.filter(item => item.pushpin)) || []
      const menuEvent = {
        click: handleClick.bind(this, menu),
        mousemove: handleMousemove.bind(this, menu),
        mouseout: handleMouseout.bind(this)
      }
      const menuStyle = menu.key === activeKey ? 'background-color:#F6F7FA;color:#077bfc;' : ''

      return (
        <div class="entry-slider-tab">
          <a href="javascript:;" class="entry-sider__menu" style={menuStyle} {...{ on: menuEvent }}>
            <div class="entry-sider__menu__hd">{ menuIcon }</div>
            <div class="entry-sider__menu__bd">{ menuTab }</div>
            { Object.keys(this.$slots).map(name => this.$slots[name]) }
          </a>
          { menuItemRender(menuChild, 1) }
        </div>
      )
    },
    menuItemRender (menus, index) {
      const {
        currentLang,
        visible,
        scrollTop,
        toggle,
        handlePushpin,
        handleMenuChange,
        handleChildrenMousemove,
        handleClearTimeout,
        menuItemRender,
        menuChildRender
      } = this

      if (index < 2) {
        return menus.map(menu => {
          const menuIcon = menu.hidden ? (<a-icon type="plus" style="transform:scale(0.7);" />) : (<a-icon type="minus" style="transform:scale(0.7);" />)
          const menuTab = menu.menuName[currentLang] || menu.tab
          const menuClass = menu.hidden ? 'entry-sider__menu-children entry-sider__menu-children--hidden' : 'entry-sider__menu-children'
          const menuStyle = visible && 'display:block;'
          const menuChild = (menu.childMenus && menu.childMenus.length && menu.childMenus) || []
          const menuEvent = { click: toggle.bind(this, menu) }
          return (
            <div class={menuClass} style={menuStyle} {...{ on: {
              mousemove: handleChildrenMousemove.bind(this),
              mouseout: handleClearTimeout.bind(this)
            } }}>
              <a href="javascript:;" class="entry-sider__menu" {...{ on: menuEvent }}>
                <div class="entry-sider__menu__hd">{ menuIcon }</div>
                <div class="entry-sider__menu__bd">{ menuTab }</div>
                <div class="entry-sider__menu__ft"
                  {...{ on: { click: handlePushpin.bind(this, { key: menu.key, pushpin: true }) } }}>
                  <a-icon type="pushpin" style="margin-left:10px;display:inline-block" />
                </div>
              </a>
              { menuItemRender(menuChild, index + 1) }
            </div>
          )
        })
      } else {
        return menus.map(menu => {
          const menuTab = menu.menuName[currentLang] || menu.tab
          const menuChildStyle = `margin-top:-${scrollTop}px;width:150px;`

          return menu.lastMenu === 2
            ? (
              <div class="entry-sider__menu-children">
                <a href="javascript:;" class="entry-sider__menu"
                  {...{ on: { click: handleMenuChange.bind(this, menu.key) } }}>
                  <div class="entry-sider__menu__bd">{ menuTab }</div>
                </a>
              </div>
            )
            : (
              <div class="entry-sider__menu-children">
                <a href="javascript:;" class="entry-sider__menu">
                  <div class="entry-sider__menu__bd">{ menuTab }</div>
                </a>
                <div class="entry-sider__menu__children" style={menuChildStyle}>
                  {menuChildRender(menu.childMenus)}
                </div>
              </div>
            )
        })
      }
    },
    menuChildRender (menus) {
      const { currentLang, handleMenuChange, menuChildRender } = this

      return menus && menus.length && menus.map(menu => {
        const menuTab = menu.menuName[currentLang] || menu.tab

        return menu.lastMenu === 2
          ? (
              <a href="javascript:;" class="entry-sider__menu__children__item"
                {...{ on: { click: handleMenuChange.bind(this, menu.key) } }}>
                {menuTab}
              </a>
            )
          : (
            <div>
              <div class="entry-sider__menu__children__item">{menuTab}</div>
              <div class="entry-sider__menu__children">
                {menuChildRender(menu.childMenus)}
              </div>
            </div>
          )
      })
    }
  },
  render (h, content) {
    const { menu, menuRender } = this
    return menuRender(menu)
  }
}
</script>

<style lang="less">
  .entry-sider__menu__children__item {
    padding: 0 10px;
    display: block;
    color: #333;
    font-size: 12px;
    line-height: 28px;
  }
  a.entry-sider__menu__children__item:hover {
    background-color: #F6F7FA;
    color: #1890ff;
  }

  .entry-sider__menu__children {
    position: relative;
    padding: 6px 16px;
  }
  .entry-sider__menu__children .entry-sider__menu__children {
    margin-top: 5px;
    padding: 0 16px;
    border-radius: 4px;
    background-color: #F6F7FA;

    &::before {
      content: " ";
      display: block;
      width: 8.48528137px;
      height: 8.48528137px;
      border-color: #F6F7FA;
      border-style: solid;
      border-width: 4.24264069px;
      position: absolute;
      left: 20px;
      top: -4px;
      transform: rotate(45deg);
    }
  }

  .entry-sider__menu-children {
    padding-left: 15px;
    position: relative;

    & & {
      padding-left: 17px;
    }

    .entry-sider__menu__hd {
      width: auto;
    }

    .entry-sider__menu:hover {
      > .entry-sider__menu__bd {
        color: #60ABFF;
      }

      > .entry-sider__menu__ft {
        display: block;
      }
    }

    > .entry-sider__menu__children {
      position: fixed;
      background: #ffffff;
      border: 1px solid #e3e3e3;
      border-radius: 2px;
      transform: translate(128px, -50%);
      z-index: 1;
    }

    .entry-slider-tab > &,
    .entry-sider__menu-children--hidden &,
    .entry-sider__menu__ft,
    > .entry-sider__menu__children {
      display: none;
    }

    &:hover > .entry-sider__menu__children {
      display: block;
    }
  }
</style>
